<mat-card>
	<mat-card-header>
		<mat-card-title>RTU Information Sheet</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		<div class="row">
			<span class="header">Unit Serial #</span>
			<span class="label">{{ card.customerServiceId }}</span>
		</div>
		<div class="row">
			<span class="header">RTU Import ID</span>
			<span class="label">{{ card.importWord }}</span>
		</div>
		<div class="row">
			<span class="header">Board Serial Number</span>
			<span class="label">{{ card.serialNumber }}</span>
		</div>
		<div class="full-content">
			<span
				>If you do not already have an AlarmAgent account, please go to
				<a [href]="activateUrl" target="_blank" class="card-link"
					>{{ activateUrl }}
				</a>
				for setup. Please make sure to have your units' serial number (H
				number) on hand.</span
			>
		</div>
	</mat-card-content>
</mat-card>
